import React, { useState } from "react";
import { managerContent as playerDexLogo } from "../assets/managerBranding";

const ClubLogo = ({ club, size = 32 }) => {
  const [failedSource, setFailedSource] = useState(null);
  const logo = club?.logo?.trim();
  const showClubLogo = Boolean(logo && logo !== failedSource);

  return (
    <img
      src={showClubLogo ? logo : playerDexLogo}
      alt={showClubLogo ? club?.name || "Club" : "PlayerDex logo"}
      onError={showClubLogo ? () => setFailedSource(logo) : undefined}
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
    />
  );
};

export default ClubLogo;
